import { render } from "./ContentSearch.vue?vue&type=template&id=60ab761c&scoped=true"
import script from "./ContentSearch.vue?vue&type=script&lang=js"
export * from "./ContentSearch.vue?vue&type=script&lang=js"

import "./ContentSearch.vue?vue&type=style&index=0&id=60ab761c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ab761c"]])

export default __exports__